var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServMob2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 182,
    viewBox: "0 0 159 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_124)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 182,
    rx: 8,
    fill: "#F6A560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3836 153.288C33.7596 153.288 34.9756 153 36.0316 152.424C37.1036 151.848 37.9436 151.056 38.5516 150.048C39.1596 149.04 39.4636 147.896 39.4636 146.616V135.12H36.1996V146.448C36.1996 147.2 36.0316 147.872 35.6956 148.464C35.3756 149.04 34.9276 149.496 34.3516 149.832C33.7916 150.152 33.1356 150.312 32.3836 150.312C31.6476 150.312 30.9916 150.152 30.4156 149.832C29.8396 149.496 29.3836 149.04 29.0476 148.464C28.7276 147.872 28.5676 147.2 28.5676 146.448V135.12H25.3036V146.616C25.3036 147.896 25.6076 149.04 26.2156 150.048C26.8236 151.056 27.6556 151.848 28.7116 152.424C29.7836 153 31.0076 153.288 32.3836 153.288ZM42.7221 153H45.9861V135.12H42.7221V153ZM48.0573 153.96H51.5133L59.4813 134.16H56.0493L48.0573 153.96ZM68.4539 153.288C69.8299 153.288 71.0459 153 72.1019 152.424C73.1739 151.848 74.0139 151.056 74.6219 150.048C75.2299 149.04 75.5339 147.896 75.5339 146.616V135.12H72.2699V146.448C72.2699 147.2 72.1019 147.872 71.7659 148.464C71.4459 149.04 70.9979 149.496 70.4219 149.832C69.8619 150.152 69.2059 150.312 68.4539 150.312C67.7179 150.312 67.0619 150.152 66.4859 149.832C65.9099 149.496 65.4539 149.04 65.1179 148.464C64.7979 147.872 64.6379 147.2 64.6379 146.448V135.12H61.3739V146.616C61.3739 147.896 61.6779 149.04 62.2859 150.048C62.8939 151.056 63.7259 151.848 64.7819 152.424C65.8539 153 67.0779 153.288 68.4539 153.288ZM77.3285 153H81.0725L85.0085 146.952L88.9205 153H92.6645L86.8325 144L92.6165 135.12H88.8725L85.0085 141.072L81.1205 135.12H77.3765L83.1845 144L77.3285 153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.913,
    cy: 40,
    r: 14,
    stroke: "#030303",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9126,
    y: 24,
    width: 32,
    height: 32,
    fill: "#EB7565"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9126,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.9126,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.9126,
    y: 56,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9126,
    y: 70,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.9126,
    y: 70,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.9126,
    y: 70,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.9126,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.9126,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.9126,
    y: 84,
    width: 4,
    height: 4,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.913 56L134.913 88V56H102.913Z",
    fill: "#FFF7F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 182,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServMob2);
export default __webpack_public_path__ + "static/media/serv_mob2.f34874b58a74dad2887c478c22ce9e4a.svg";
export { ForwardRef as ReactComponent };